import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { DOCS_URL } from 'api/meedioBackend/apiKeys/constants';
import { ReactComponent as ExternalLink } from 'assets/icons/ExternalLink.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import testingConstants from 'utils/testingConstants';

const ApiKeysDocumentationRow = () => {
  const { t } = useTranslation();

  const handleOpenDocs = () => {
    window.open(DOCS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
      <div className="flex w-full flex-col space-y-1">
        <SettingsCard.Content.Title>{t('workspaces_settings.api_keys.documentation.title')}</SettingsCard.Content.Title>
        <SettingsCard.Content.Description>
          {t('workspaces_settings.api_keys.documentation.description')}
        </SettingsCard.Content.Description>
      </div>
      <Button
        variant="secondaryTertiary"
        size="sm"
        onClick={handleOpenDocs}
        data-testid={testingConstants.apiKeysDocumentationButton}
        iconRight={{ icon: ExternalLink, className: 'stroke-current stroke-1.5' }}
        className="w-full md:w-fit"
      >
        {t('workspaces_settings.api_keys.documentation.button')}
      </Button>
    </div>
  );
};

export default ApiKeysDocumentationRow;
